import React from 'react';
import { BaseInternetNode, INTERNET_NODE_TITLE } from './BaseInternetNode';

const InternetNode: React.FC = () => {
    return <BaseInternetNode title={INTERNET_NODE_TITLE} iconName={'web'} />;
};

export default InternetNode;
